import { indexItems } from '@/mocks/homeData';

const indexImages = [
  'https://readdy.ai/api/search-image?query=dramatic%20warm%20toned%20entertainment%20industry%20abstract%2C%20crimson%20and%20gold%2C%20soft%20bokeh%2C%20editorial%20style%2C%20no%20text%2C%20mysterious&width=400&height=400&seq=index-01-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=dark%20warm%20toned%20social%20media%20influencer%20abstract%2C%20crimson%20glow%2C%20editorial%20photography%2C%20no%20text%2C%20mysterious%20mood&width=400&height=400&seq=index-02-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=warm%20toned%20gaming%20esports%20abstract%2C%20dark%20amber%20and%20crimson%2C%20soft%20dramatic%20lighting%2C%20editorial%20style%2C%20no%20text&width=400&height=400&seq=index-03-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=dramatic%20backstage%20tv%20show%20abstract%2C%20crimson%20and%20gold%20spotlight%2C%20editorial%20photography%2C%20no%20text%2C%20mysterious&width=400&height=400&seq=index-04-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=warm%20toned%20music%20industry%20abstract%2C%20crimson%20ambient%20light%2C%20editorial%20style%2C%20no%20text%2C%20mysterious%20mood&width=400&height=400&seq=index-05-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=dark%20warm%20film%20industry%20abstract%2C%20crimson%20and%20amber%20accents%2C%20soft%20bokeh%2C%20editorial%20style%2C%20no%20text&width=400&height=400&seq=index-06-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=warm%20toned%20fashion%20industry%20abstract%2C%20crimson%20gradients%2C%20editorial%20photography%2C%20no%20text%2C%20mysterious%20elegant&width=400&height=400&seq=index-07-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=dramatic%20sports%20abstract%2C%20dark%20crimson%20and%20amber%20mood%2C%20editorial%20style%2C%20no%20text%2C%20mysterious%20atmosphere&width=400&height=400&seq=index-08-51cg&orientation=squarish',
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full bg-background-100 py-14 md:py-20 px-4 md:px-6 lg:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-foreground-950 font-heading font-bold text-2xl md:text-3xl lg:text-4xl mb-3">
            专题索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            按圈子分类浏览，快速找到你关注的领域
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#index"
              className="group relative aspect-square rounded-xl overflow-hidden cursor-pointer block"
            >
              <img
                src={indexImages[idx]}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-6">
                <h3 className="text-white font-heading font-bold text-lg md:text-xl leading-snug mb-1">
                  {item.title}
                </h3>
                <p className="text-white/70 text-xs md:text-sm">
                  {item.subtitle}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}